// transcript handlers intentionally empty — requests pass through to real backend
export const transcriptHandlers = []
